import { Component, OnDestroy } from '@angular/core';
import { CommonDossierComponent } from '@kv-common-components/kv-common-components';
import { NGXLogger } from 'ngx-logger';
import {
    AuthenticationService,
    EspaceClientService,
    EspaceDocumentaireService,
    User,
} from '@kv-common-components/kx-services';
import { StyleService } from '@shared/services/style.service';
import { Router } from '@angular/router';
import { DocumentListHelperService } from '@shared/services/document-list-helper.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-next-step-introduction',
    templateUrl: './next-step-introduction.component.html',
    styleUrls: [],
})
export class NextStepIntroductionComponent
    extends CommonDossierComponent
    implements OnDestroy
{
    personne: any;
    currentUser: User;
    expectedMedicalDocs: any;
    expectedMedicalDocsAreLoading = false;
    passedDataFromPreviousPage: any[];

    espaceClientSubscription: Subscription;

    constructor(
        protected logger: NGXLogger,
        protected espaceDocumentaireService: EspaceDocumentaireService,
        private authenticationService: AuthenticationService,
        private espaceClientService: EspaceClientService,
        protected styleService: StyleService,
        protected router: Router
    ) {
        super(logger, espaceDocumentaireService);
        if (history.state && history.state.data) {
            this.passedDataFromPreviousPage = history.state.data;
        }
        this.expectedMedicalDocsAreLoading = true;
        this.styleService.updatePageStyle('add', 'next-step-introduction-page');
        this.espaceClientSubscription =
            this.espaceClientService.currentEspaceClient.subscribe(
                (espaceClient) => {
                    this.currentUser =
                        this.authenticationService.currentUserValue;
                    this.personne = espaceClient.personne;
                    this.espaceDocumentaireService
                        .getEspaceDocumentaire(
                            this.personne.idPersonne,
                            this.currentUser.idPropositionPrincipale
                        )
                        .subscribe((espaceDocumentaire) => {
                            this.allDocuments = espaceDocumentaire;
                            this.setDocs();
                            this.expectedMedicalDocsAreLoading = false;
                        });
                }
            );
    }
    ngOnDestroy(): void {
        this.styleService.updatePageStyle(
            'remove',
            'next-step-introduction-page'
        );

        if (this.espaceClientSubscription) {
            this.espaceClientSubscription.unsubscribe();
        }
    }

    setDocs(): void {
        this.logger.debug({ allDocs: this.allDocuments });
        this.expectedMedicalDocs =
            DocumentListHelperService.getLastDocumentForExpectedMedicalDocs(
                this.allDocuments
            );
    }

    handleCloseClick(): void {
        const previousPageUrl = localStorage.getItem('previousPageUrl');
        this.router.navigateByUrl(previousPageUrl, {
            state: { data: this.passedDataFromPreviousPage },
        });
    }
}
